import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UPUnauthorizedComponent } from 'up';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth.guard';
import { ErrorComponent } from './shared/components/error/error.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'unauthorized',
    component: UPUnauthorizedComponent,
  },
  {
    path: 'instructor',
    loadChildren: () =>
      import('./instructor/instructor.module').then((m) => m.InstructorModule),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'instructor' },
  },
  {
    path: 'ebook',
    loadChildren: () =>
      import('./shared/shared.module').then((m) => m.SharedModule),
    canActivate: [AuthGuard],
    data: { authorizedRole: 'learner' },
  },
  {
    path: '**',
    component: ErrorComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
